import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _19819baa = () => interopDefault(import('..\\..\\..\\pages\\adminPanel.vue' /* webpackChunkName: "pages/adminPanel" */))
const _492bafef = () => interopDefault(import('..\\..\\..\\pages\\dashboard.vue' /* webpackChunkName: "pages/dashboard" */))
const _6773df7a = () => interopDefault(import('..\\..\\..\\pages\\editprofile.vue' /* webpackChunkName: "pages/editprofile" */))
const _05dc40ab = () => interopDefault(import('..\\..\\..\\pages\\entries.vue' /* webpackChunkName: "pages/entries" */))
const _16c91bc4 = () => interopDefault(import('..\\..\\..\\pages\\login.vue' /* webpackChunkName: "pages/login" */))
const _7a2b0b6c = () => interopDefault(import('..\\..\\..\\pages\\newassignmentteacher.vue' /* webpackChunkName: "pages/newassignmentteacher" */))
const _65c16f0b = () => interopDefault(import('..\\..\\..\\pages\\scientificProject.vue' /* webpackChunkName: "pages/scientificProject" */))
const _0561b5da = () => interopDefault(import('..\\..\\..\\pages\\assignment\\_assignment.vue' /* webpackChunkName: "pages/assignment/_assignment" */))
const _6bc13616 = () => interopDefault(import('..\\..\\..\\pages\\assignmentTeacher\\_editAssignment.vue' /* webpackChunkName: "pages/assignmentTeacher/_editAssignment" */))
const _61de1e3a = () => interopDefault(import('..\\..\\..\\pages\\categories\\_categories.vue' /* webpackChunkName: "pages/categories/_categories" */))
const _20fab6a6 = () => interopDefault(import('..\\..\\..\\pages\\courses\\_index.vue' /* webpackChunkName: "pages/courses/_index" */))
const _bc74e5c4 = () => interopDefault(import('..\\..\\..\\pages\\draft\\_draft.vue' /* webpackChunkName: "pages/draft/_draft" */))
const _e2da2c8c = () => interopDefault(import('..\\..\\..\\pages\\enteredSubmissions\\_enteredSubmissions.vue' /* webpackChunkName: "pages/enteredSubmissions/_enteredSubmissions" */))
const _41430e2e = () => interopDefault(import('..\\..\\..\\pages\\lvs\\_lvs.vue' /* webpackChunkName: "pages/lvs/_lvs" */))
const _83eda70c = () => interopDefault(import('..\\..\\..\\pages\\post\\_post.vue' /* webpackChunkName: "pages/post/_post" */))
const _32cf612e = () => interopDefault(import('..\\..\\..\\pages\\profile\\_profile.vue' /* webpackChunkName: "pages/profile/_profile" */))
const _90086f8c = () => interopDefault(import('..\\..\\..\\pages\\search\\_search.vue' /* webpackChunkName: "pages/search/_search" */))
const _f69b325c = () => interopDefault(import('..\\..\\..\\pages\\submitted\\_submitted.vue' /* webpackChunkName: "pages/submitted/_submitted" */))
const _753e0e0c = () => interopDefault(import('..\\..\\..\\pages\\submittedStudent\\_submittedStudent.vue' /* webpackChunkName: "pages/submittedStudent/_submittedStudent" */))
const _c01ad002 = () => interopDefault(import('..\\..\\..\\pages\\assignmentTeacher\\_LV\\_assignmentTeacher.vue' /* webpackChunkName: "pages/assignmentTeacher/_LV/_assignmentTeacher" */))
const _4d2178ad = () => interopDefault(import('..\\..\\..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _890d498c = () => interopDefault(import('..\\..\\..\\pages\\_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/adminPanel",
    component: _19819baa,
    name: "adminPanel"
  }, {
    path: "/dashboard",
    component: _492bafef,
    name: "dashboard"
  }, {
    path: "/editprofile",
    component: _6773df7a,
    name: "editprofile"
  }, {
    path: "/entries",
    component: _05dc40ab,
    name: "entries"
  }, {
    path: "/login",
    component: _16c91bc4,
    name: "login"
  }, {
    path: "/newassignmentteacher",
    component: _7a2b0b6c,
    name: "newassignmentteacher"
  }, {
    path: "/scientificProject",
    component: _65c16f0b,
    name: "scientificProject"
  }, {
    path: "/assignment/:assignment?",
    component: _0561b5da,
    name: "assignment-assignment"
  }, {
    path: "/assignmentTeacher/:editAssignment?",
    component: _6bc13616,
    name: "assignmentTeacher-editAssignment"
  }, {
    path: "/categories/:categories?",
    component: _61de1e3a,
    name: "categories-categories"
  }, {
    path: "/courses/:index",
    component: _20fab6a6,
    name: "courses"
  }, {
    path: "/draft/:draft?",
    component: _bc74e5c4,
    name: "draft-draft"
  }, {
    path: "/enteredSubmissions/:enteredSubmissions?",
    component: _e2da2c8c,
    name: "enteredSubmissions-enteredSubmissions"
  }, {
    path: "/lvs/:lvs?",
    component: _41430e2e,
    name: "lvs-lvs"
  }, {
    path: "/post/:post?",
    component: _83eda70c,
    name: "post-post"
  }, {
    path: "/profile/:profile?",
    component: _32cf612e,
    name: "profile-profile"
  }, {
    path: "/search/:search?",
    component: _90086f8c,
    name: "search-search"
  }, {
    path: "/submitted/:submitted?",
    component: _f69b325c,
    name: "submitted-submitted"
  }, {
    path: "/submittedStudent/:submittedStudent?",
    component: _753e0e0c,
    name: "submittedStudent-submittedStudent"
  }, {
    path: "/assignmentTeacher/:LV?/:assignmentTeacher?",
    component: _c01ad002,
    name: "assignmentTeacher-LV-assignmentTeacher"
  }, {
    path: "/",
    component: _4d2178ad,
    name: "index"
  }, {
    path: "/*",
    component: _890d498c,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config.app && config.app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
